module.exports = __webpack_public_path__ + "static/img/COMIX.09d9dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/COMIX.png
// module id = I8KD
// module chunks = 34